import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DataService } from '../services/data.service';
import { API_ENDPOINT$ } from '../shared/index';

@Injectable({
  providedIn: 'root'
})
export class ClickAndNavigationService {
  private getEnergyOperatingHoursUrl = `${API_ENDPOINT$}/common/getEnergyOperatingHours`;
  private getAttachmentsForNodeUrl = `${API_ENDPOINT$}/common/getAttachmentsForNode`;
  private getEnergyOperatingHoursForLoadUrl = `${API_ENDPOINT$}/common/getEnergyOperatingHoursForLoad`;
  private getSensorTrendsUrl = `${API_ENDPOINT$}/common/getSensorTrends`;
  constructor(private dataService: DataService) {}
  public getEnergyOperatingHours(quickStatParams: any): Observable<any> {
    return this.dataService.postData(
      this.getEnergyOperatingHoursUrl,
      quickStatParams
    );
  }
  public getAttachmentsForNode(params: any): Observable<any> {
    return this.dataService.postData(this.getAttachmentsForNodeUrl, params);
  }
  public getEnergyOperatingHoursForLoad(quickStatParams: any): Observable<any> {
    return this.dataService.postData(
      this.getEnergyOperatingHoursForLoadUrl,
      quickStatParams
    );
  }

  public getImage(imageUrl: string): Observable<Blob> {
    return this.dataService.getImageContent(imageUrl);
  }
  public getSensorTrends(params: any): Observable<any> {
    return this.dataService.postData(this.getSensorTrendsUrl, params);
  }
}
